import React from 'react';
import { path, sortWith, descend, compose, defaultTo, map } from 'ramda';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';

import { formatDate, dateValue } from 'lib/dateDisplay';

export const sorter = sortWith([descend(compose(dateValue, path(['content', 'contactDate'])))]);

const msg = id => ({ id });

const renderEntryHeader = (doc, fm) => `${formatDate(doc.content.contactDate)}`;

const optionAccessor = opt => `next.opts.${opt}`;
const localizeValue = (fm, value) => fm({ id: optionAccessor(value) });

const historyMapper =
  (name, edit) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={renderEntryHeader(d, formatMessage)} active>
        {window.__ROLE__ !== 'DOCTOR' && (
          <CommonHistoryEntryControls action={() => edit(name, d.documentId, d.content)} />
        )}
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={formatMessage(msg('next.labels.contactType'))} smallScaling={12}>
          <p>{d.content.contactType && localizeValue(formatMessage, d.content.contactType)}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={formatMessage(msg('next.labels.contactSubjectShort'))} smallScaling={12}>
          {map(d => <p key={d} children={localizeValue(formatMessage, d)} />)(defaultTo([])(d.content.contactSubject))}
        </HistoryEntryColumn>
        {d.content.otherDetail && (
          <HistoryEntryColumn header={formatMessage(msg('next.labels.other'))} smallScaling={12}>
            <p>{d.content.otherDetail}</p>
          </HistoryEntryColumn>
        )}
        {!d.content.otherDetail && (
          <HistoryEntryColumn header={''}>
            <p />
          </HistoryEntryColumn>
        )}
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
